export const ANALYTICS = {
  CATEGORIES: {
    NAVIGATION: 'Navigation',
  },
  EVENTS: {
    PURCHASE: 'Purchase',
    PURCHASE_ERROR: 'Purchase Error',
    CLICKED_BUTTON: 'Clicked Button',
    ADD_TO_CART: 'Add To Cart',
    ADD_TO_CART_ERROR: 'Error: Add To Cart',
    VIEWED_PAGE: 'Viewed Page',
    VIEWED_COMPONENT: 'Viewed Component',
    CONTROL_VIEWED_PAGE: 'Control Pilot - Viewed Page',
    CURRENT_VIEWED_PAGE: 'Current Pilot - Viewed Page',
    CONTROL_ENROLL_BUTTON_CLICK: 'Control Pilot - Enroll Button Click',
    CONTROL_ALREADY_ENROLLED: 'Control Pilot - Already Enrolled',
    STI_VIEWED_PAGE: 'STI Pilot - Viewed Page',
    STI_CLICKED_BUTTON: 'STI Pilot - Clicked Button',
    MEMBERSHIP_CLICKED_BUTTON: 'Membership Pilot - Clicked Product Button',
    STI_ENROLL_BUTTON_CLICK: 'STI Pilot - Enroll Button Click',
    STI_ALREADY_ENROLLED: 'STI Pilot - Already Enrolled',
    SCROLLED_TO_BOTTOM: 'Scrolled to bottom of page',
    RESTRICTED_STATE_ERROR: 'Restricted State Error',
    QUANTITY_SELECT: 'Quantity Changed',
    SUBSCRIPTION_SELECT: 'Subscribtion Selected',
    CHANGED_FREQUENCY: 'Changed Subscription Frequency',
    CHANGE_FREQUENCY_CLICKED: 'Clicked Change Frequency',
    PURCHASE_TYPE: 'Changed Purchase Type',
    OPEN_REVIEWS_MODAL: 'Opened Reviews Modal',
    FAQ_CLICK: 'Opened FAQ',
    HERO_SLIDE: 'PDP Hero Slide',
  },
  LABELS: {
    ADD_TO_CART: 'Add to Cart',
    LEARN_MORE: 'Learn More',
    VIEWED_TEST_MARKERS: 'Viewed Test Markers',
    HOMEPAGE_HERO_CTA: 'Homepage Hero CTA',
    HOMEPAGE_HERO_CATEGORY: 'Homepage Hero Category',
    HOMEPAGE_COVID_CTA: 'Homepage COVID CTA',
    HOMEPAGE_POPULAR_ALL_TESTS_CTA: 'Homepage Popular All Tests CTA',
    PDP_MORE_TESTS_CTA: 'PDP MoreTests CTA',
    HOMEPAGE_POPULAR_PRODUCT_CARD: 'Homepage Popular Product Card',
    PDP_POPULAR_PRODUCT_CARD: 'PDP Popular Product Card',
    HOMEPAGE_FOR_BUSINESS_CTA: 'Homepage For Business CTA',
    HOMEPAGE: 'Homepage',
    PIP_PRODUCT_CARD: 'Product Index Page (PIP) Product Card',
    EXPRESS_PAY_PDP: 'PDP Express Pay Purchase',
    EXPRESS_PAY_CART: 'DLS Cart Express Pay Purchase',
    ADD_TO_CART_MODAL: 'Add to Cart via Modal',
    ADD_TO_CART_UPGRADE_MODAL_NO_UPGRADE:
      'Add Non-upgraded Item to Cart via Upgrade Modal',
    ADD_TO_CART_UPGRADE_MODAL_WITH_UPGRADE:
      'Add Upgraded Item to Cart via Upgrade Modal',
    PDP_UPGRADE_MODAL: 'PDP Upgrade Modal',
    ADD_TO_CART_PDP_PRODUCT_CARD: 'Add to Cart via PDP Product Card',
    NO_COVID_SYMPTOMS: 'No COVID-19 symptoms',
    MILD_COVID_SYMPTOMS: 'Mild COVID-19 symptoms',
    SEVERE_COVID_SYMPTOMS: 'Severe COVID-19 symptoms',
    NO_COVID_EXPOSURE: 'No COVID-19 exposure',
    POTENTIAL_COVID_EXPOSURE: 'COVID-19 city exposure',
    SUSPECTED_COVID_EXPOSURE: 'COVID-19 close to undiagnosed',
    KNOWN_COVID_EXPOSURE: 'COVID-19 close to diagnosed',
    INTAKE_SYMPTOMS_COVID_SCREENER: 'COVID-19 Intake Symptoms',
    INTAKE_EXPOSURE_COVID_SCREENER: 'COVID-19 Intake Exposure',
    NOT_RECOMMENDED_COVID_SCREENER: 'COVID-19 Not recommended',
    SEEK_MEDICAL_CARE_COVID_SCREENER: 'COVID-19 Seek medical care',
    INTAKE_COVID_CHECKOUT: '/covid-checkout',
  },
};
